document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-nav-links]');
  if (toggle && nav) toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  const megaRegion = nav;
  const hoverRegion = nav?.closest('.template-index .site-header') || nav;
  const megaMenus = megaRegion ? [...megaRegion.querySelectorAll('[data-mega]')] : [];
  const desktopLayout = window.matchMedia('(min-width: 901px)');
  const desktopHover = window.matchMedia('(min-width: 901px) and (hover: hover) and (pointer: fine)');
  let activeMega = null;
  let openTimer;
  let closeTimer;
  let switchGeneration = 0;
  let suppressFocusOpen = false;

  const setMegaOpen = (mega, open) => {
    mega.classList.toggle('is-open', open);
    mega.querySelector('[data-mega-toggle]')?.setAttribute('aria-expanded', String(open));
  };

  const finishInstantSwitch = (generation) => {
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      if (generation === switchGeneration) megaRegion?.classList.remove('is-mega-switching');
    }));
  };

  const activateMega = (mega, instant = false) => {
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    if (activeMega === mega && mega.classList.contains('is-open')) return;

    const isSwitching = instant && activeMega && activeMega !== mega;
    if (isSwitching) megaRegion?.classList.add('is-mega-switching');

    megaMenus.forEach((item) => setMegaOpen(item, item === mega));
    activeMega = mega;

    if (isSwitching) finishInstantSwitch(++switchGeneration);
  };

  const closeMegas = () => {
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    switchGeneration += 1;
    megaRegion?.classList.remove('is-mega-switching');
    megaMenus.forEach((mega) => setMegaOpen(mega, false));
    activeMega = null;
  };

  megaMenus.forEach((mega) => {
    const megaToggle = mega.querySelector('[data-mega-toggle]');
    const megaTrigger = mega.querySelector('.mega-trigger') || mega;
    if (!megaToggle) return;

    megaToggle.addEventListener('click', () => {
      if (mega.classList.contains('is-open')) closeMegas();
      else activateMega(mega, Boolean(activeMega && activeMega !== mega));
    });

    megaTrigger.addEventListener('pointerenter', () => {
      if (!desktopHover.matches) return;
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);

      if (!mega.classList.contains('is-open')) {
        openTimer = window.setTimeout(() => activateMega(mega, Boolean(activeMega && activeMega !== mega)), 200);
      }
    });
    megaTrigger.addEventListener('pointerleave', () => {
      if (desktopHover.matches) window.clearTimeout(openTimer);
    });

    mega.addEventListener('focusin', () => {
      if (desktopLayout.matches && !suppressFocusOpen) activateMega(mega, Boolean(activeMega && activeMega !== mega));
    });
    mega.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!desktopLayout.matches) {
        if (!mega.classList.contains('is-open')) return;
        event.stopPropagation();
      }
      suppressFocusOpen = true;
      closeMegas();
      (mega.querySelector('.mega-link') || megaToggle).focus();
      window.requestAnimationFrame(() => { suppressFocusOpen = false; });
    });
  });

  hoverRegion?.addEventListener('pointerenter', () => {
    if (!desktopHover.matches) return;
    window.clearTimeout(closeTimer);
  });

  hoverRegion?.addEventListener('pointerleave', () => {
    if (!desktopHover.matches) return;
    window.clearTimeout(openTimer);
    closeTimer = window.setTimeout(closeMegas, 160);
  });

  megaRegion?.addEventListener('focusout', (event) => {
    if (!megaRegion.contains(event.relatedTarget) && !(desktopHover.matches && hoverRegion.matches(':hover'))) closeMegas();
  });

  document.addEventListener('click', (event) => {
    if (megaRegion && !megaRegion.contains(event.target)) closeMegas();
  });

  desktopHover.addEventListener?.('change', closeMegas);

  const catalog = document.querySelector('[data-bloom-catalog]');
  if (catalog) {
    const cards = [...catalog.querySelectorAll('[data-bloom-product]')];
    const filterInputs = [...catalog.querySelectorAll('[data-bloom-filter]')];
    const filterKeys = ['family', 'benefit', 'goal', 'format', 'composition', 'subtype', 'available'];
    const priceMin = catalog.querySelector('[data-price-min]');
    const priceMax = catalog.querySelector('[data-price-max]');
    const activeFilters = catalog.querySelector('[data-active-filters]');
    const visibleCounts = [...catalog.querySelectorAll('[data-visible-count]')];
    const mobileCount = catalog.querySelector('[data-mobile-result-count]');
    const noResults = catalog.querySelector('[data-no-results]');
    const filterPanel = catalog.querySelector('[data-filter-panel]');
    const filterOpen = catalog.querySelector('[data-filter-open]');
    const selectedCount = catalog.querySelector('[data-selected-filter-count]');
    let priceTimer;

    const valuesFor = (card, key) => String(card.dataset[key] || '').split('|').filter(Boolean);
    const readCriteria = () => {
      const criteria = {};
      filterKeys.forEach((key) => {
        criteria[key] = filterInputs.filter((input) => input.dataset.bloomFilter === key && input.checked).map((input) => input.value);
      });
      criteria.priceMin = Math.max(0, Number(priceMin?.value || 0));
      criteria.priceMax = priceMax?.value ? Math.max(0, Number(priceMax.value)) : null;
      return criteria;
    };
    const matches = (card, criteria) => {
      for (const key of filterKeys) {
        const selected = criteria[key] || [];
        if (!selected.length) continue;
        const available = valuesFor(card, key);
        if (!selected.some((value) => available.includes(value))) return false;
      }
      const cardPrice = Number(card.dataset.price || 0) / 100;
      if (criteria.priceMin && cardPrice < criteria.priceMin) return false;
      if (criteria.priceMax !== null && cardPrice > criteria.priceMax) return false;
      return true;
    };
    const syncOptionCounts = (criteria) => {
      catalog.querySelectorAll('[data-filter-group]').forEach((group) => {
        const options = [...group.querySelectorAll('[data-filter-option]')];
        options.forEach((option) => {
          const input = option.querySelector('[data-bloom-filter]');
          if (!input) return;
          const filterKey = input.dataset.bloomFilter;
          const testCriteria = {...criteria};
          testCriteria[filterKey] = [input.value];
          const count = cards.filter((card) => matches(card, testCriteria)).length;
          const countNode = option.querySelector('[data-filter-count]');
          if (countNode) countNode.textContent = String(count);

          const hasProducts = cards.some((card) => valuesFor(card, filterKey).includes(input.value));
          option.hidden = (desktopLayout.matches ? count === 0 : !hasProducts) && !input.checked;
          input.disabled = count === 0 && !input.checked;
        });
        const meaningfulOptions = options.filter((option) => !option.hidden || option.querySelector('input:checked'));
        group.hidden = meaningfulOptions.length < 2
          && !meaningfulOptions.some((option) => option.querySelector('input:checked'));
      });
    };
    const writeUrl = (criteria) => {
      const url = new URL(window.location.href);
      filterKeys.forEach((key) => {
        const parameter = `filter.bloom.${key}`;
        url.searchParams.delete(parameter);
        (criteria[key] || []).forEach((value) => url.searchParams.append(parameter, value));
      });
      url.searchParams.delete('filter.bloom.price_min');
      url.searchParams.delete('filter.bloom.price_max');
      if (criteria.priceMin) url.searchParams.set('filter.bloom.price_min', String(criteria.priceMin));
      if (criteria.priceMax !== null) url.searchParams.set('filter.bloom.price_max', String(criteria.priceMax));
      url.searchParams.delete('page');
      window.history.replaceState({}, '', url);
    };
    const filterLabel = (input) => input.closest('[data-filter-option]')?.querySelector('span')?.textContent.trim() || input.value;
    const renderActiveFilters = (criteria) => {
      if (!activeFilters) return;
      activeFilters.innerHTML = '';
      filterInputs.filter((input) => input.checked).forEach((input) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.dataset.removeFilter = input.dataset.bloomFilter;
        chip.dataset.removeValue = input.value;
        chip.textContent = `${filterLabel(input)} ×`;
        activeFilters.appendChild(chip);
      });
      if (criteria.priceMin || criteria.priceMax !== null) {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.dataset.removePrice = 'true';
        chip.textContent = `${criteria.priceMin ? `₱${criteria.priceMin.toLocaleString()}` : 'Any'} – ${criteria.priceMax !== null ? `₱${criteria.priceMax.toLocaleString()}` : 'Any'} ×`;
        activeFilters.appendChild(chip);
      }
      if (activeFilters.children.length) {
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.dataset.clearFilters = 'true';
        clear.className = 'v5-active-filters__clear';
        clear.textContent = 'Clear all';
        activeFilters.appendChild(clear);
      }
    };
    const applyFilters = (updateUrl = true) => {
      window.clearTimeout(priceTimer);
      const criteria = readCriteria();
      const selectedTotal = filterInputs.filter((input) => input.checked).length + Number(Boolean(criteria.priceMin || criteria.priceMax !== null));
      if (selectedCount) {
        selectedCount.textContent = String(selectedTotal);
        selectedCount.hidden = selectedTotal === 0;
        selectedCount.setAttribute('aria-label', catalog.dataset.filterCountLabel.replace('__count__', String(selectedTotal)));
      }
      catalog.querySelectorAll('.v5-filters__mobile-status [data-clear-filters]').forEach((button) => { button.disabled = selectedTotal === 0; });
      let shown = 0;
      cards.forEach((card) => {
        const visible = matches(card, criteria);
        card.hidden = !visible;
        if (visible) shown += 1;
      });
      catalog.querySelectorAll('[data-product-group]').forEach((group) => {
        const groupCards = [...group.querySelectorAll('[data-bloom-product]')];
        const groupShown = groupCards.filter((card) => !card.hidden).length;
        group.hidden = groupShown === 0;
        const countNode = group.querySelector('[data-group-count]');
        if (countNode) countNode.textContent = `${groupShown} ${groupShown === 1 ? 'product' : 'products'}`;
      });
      visibleCounts.forEach((node) => { node.textContent = String(shown); });
      if (mobileCount) mobileCount.textContent = String(shown);
      if (noResults) noResults.hidden = shown !== 0;
      syncOptionCounts(criteria);
      renderActiveFilters(criteria);
      if (updateUrl) writeUrl(criteria);
    };
    const clearFilters = () => {
      filterInputs.forEach((input) => { input.checked = false; });
      if (priceMin) priceMin.value = '';
      if (priceMax) priceMax.value = '';
      applyFilters(true);
    };
    const closeFilterPanel = () => {
      filterPanel?.classList.remove('is-open');
      filterOpen?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('filters-open');
    };

    const initialUrl = new URL(window.location.href);
    filterInputs.forEach((input) => {
      input.checked = initialUrl.searchParams.getAll(`filter.bloom.${input.dataset.bloomFilter}`).includes(input.value);
    });
    filterInputs.filter((input) => input.checked).forEach((input) => input.closest('details')?.setAttribute('open', ''));
    if (priceMin) priceMin.value = initialUrl.searchParams.get('filter.bloom.price_min') || '';
    if (priceMax) priceMax.value = initialUrl.searchParams.get('filter.bloom.price_max') || '';
    applyFilters(false);

    filterInputs.forEach((input) => input.addEventListener('change', () => applyFilters(true)));
    [priceMin, priceMax].filter(Boolean).forEach((input) => {
      input.addEventListener('input', () => {
        window.clearTimeout(priceTimer);
        priceTimer = window.setTimeout(() => applyFilters(true), 350);
      });
      input.addEventListener('change', () => applyFilters(true));
    });
    [priceMin, priceMax].filter(Boolean).forEach((input) => input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyFilters(true);
      }
    }));
    activeFilters?.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button) return;
      if (button.dataset.clearFilters) return clearFilters();
      if (button.dataset.removePrice) {
        if (priceMin) priceMin.value = '';
        if (priceMax) priceMax.value = '';
        return applyFilters(true);
      }
      const input = filterInputs.find((candidate) => candidate.dataset.bloomFilter === button.dataset.removeFilter && candidate.value === button.dataset.removeValue);
      if (input) input.checked = false;
      applyFilters(true);
    });
    catalog.querySelectorAll('[data-clear-filters]').forEach((button) => button.addEventListener('click', clearFilters));
    filterOpen?.addEventListener('click', () => {
      filterPanel?.classList.add('is-open');
      filterOpen.setAttribute('aria-expanded', 'true');
      document.body.classList.add('filters-open');
    });
    catalog.querySelector('[data-filter-close]')?.addEventListener('click', closeFilterPanel);
    desktopLayout.addEventListener?.('change', () => syncOptionCounts(readCriteria()));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && filterPanel?.classList.contains('is-open')) closeFilterPanel();
    });
    catalog.querySelector('[data-bloom-sort]')?.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  document.querySelectorAll('.v3-product-page').forEach((page) => {
    const gallery = page?.querySelector('.v3-product-gallery');
    const mediaStage = gallery?.querySelector('.v3-product-media');
    let mainImage = mediaStage?.querySelector('img');
    const thumbnails = [...(gallery?.querySelectorAll('[data-product-thumbnail]') || [])];

    let mediaSwitchToken = 0;
    let displayedMediaId = thumbnails.find((thumbnail) => thumbnail.getAttribute('aria-pressed') === 'true')?.dataset.mediaId;
    const setProductMedia = async (media) => {
      if (!media?.src || !mainImage) return;

      const token = ++mediaSwitchToken;
      thumbnails.forEach(thumbnail => thumbnail.setAttribute('aria-pressed', String(thumbnail.dataset.mediaId === String(media.mediaId))));
      mediaStage?.setAttribute('aria-busy', 'true');

      const nextImage = mainImage.cloneNode(false);
      nextImage.removeAttribute('src');
      nextImage.removeAttribute('srcset');
      nextImage.decoding = 'async';
      nextImage.loading = 'eager';
      nextImage.fetchPriority = 'high';
      nextImage.sizes = mainImage.sizes || '(min-width: 901px) 58vw, 100vw';
      nextImage.alt = media.alt || '';

      if (media.srcset) nextImage.srcset = media.srcset;
      nextImage.src = media.src;

      try {
        await nextImage.decode();
      } catch (error) {
        if (!nextImage.complete) {
          await new Promise((resolve) => {
            nextImage.addEventListener('load', resolve, { once: true });
            nextImage.addEventListener('error', resolve, { once: true });
          });
        }
      }

      if (token !== mediaSwitchToken) return;
      if (!nextImage.naturalWidth) {
        thumbnails.forEach((thumbnail) => thumbnail.setAttribute('aria-pressed', String(thumbnail.dataset.mediaId === displayedMediaId)));
        mediaStage?.removeAttribute('aria-busy');
        return;
      }

      displayedMediaId = String(media.mediaId);
      mainImage.replaceWith(nextImage);
      mainImage = nextImage;
      mediaStage?.classList.toggle('is-test-results', media.role === 'test-results');
      mediaStage?.removeAttribute('aria-busy');
    };
    thumbnails.forEach(thumbnail => thumbnail.addEventListener('click', () => setProductMedia({
      mediaId: thumbnail.dataset.mediaId,
      src: thumbnail.dataset.mediaSrc,
      srcset: thumbnail.dataset.mediaSrcset,
      alt: thumbnail.dataset.mediaAlt,
      role: thumbnail.dataset.mediaRole
    })));
  });

  document.querySelectorAll('[data-product-form]').forEach((root) => {
    const variants = JSON.parse(root.querySelector('[data-variants-json]').textContent);
    let submitting = false;
    const selectors = [...root.querySelectorAll('[data-option-selector]')];
    const optionButtons = [...root.querySelectorAll('[data-option-button]')];
    const variantInput = root.querySelector('[name="id"]');
    const price = root.closest('.v3-product-info, .product-info')?.querySelector('[data-product-price]');
    const summary = root.querySelector('[data-selection-summary]');
    const button = root.querySelector('[data-add-button]');
    const formatSelector = selectors.find((el) => el.dataset.optionName.toLowerCase() === 'format');
    const formatPriceNotes = [...root.querySelectorAll('[data-format-price-note]')];
    const extraDialog = root.querySelector('[data-extra-dialog]');
    const formStatus = root.querySelector('[data-product-form-status]');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const quantityDecrease = root.querySelector('[data-quantity-decrement]');
    const quantityIncrease = root.querySelector('[data-quantity-increment]');
    const orderPanel = root.querySelector('[data-order-panel]');
    const orderInstagram = orderPanel?.querySelector('[data-order-instagram]');
    const orderWhatsApp = orderPanel?.querySelector('[data-order-whatsapp]');
    const orderDialog = orderPanel?.querySelector('[data-order-dialog]');
    const orderMessage = orderPanel?.querySelector('[data-order-message]');
    const orderCopyStatus = orderPanel?.querySelector('[data-order-copy-status]');
    const orderFallback = orderPanel?.querySelector('[data-order-fallback]');

    const money = cents => new Intl.NumberFormat('en-PH', {style:'currency', currency:'PHP', minimumFractionDigits:0, maximumFractionDigits:0}).format(cents / 100);
    const updateOptionPremiums = (selected) => {
      optionButtons.forEach((optionButton) => {
        const note = optionButton.querySelector('[data-option-price-note]');
        if (!note) return;
        const optionIndex = Number(optionButton.dataset.optionIndex);
        const comparableVariants = variants.filter((candidate) =>
          candidate.options.every((value, index) => index === optionIndex || value === selected[index])
        );
        const choice = comparableVariants.find((candidate) => candidate.options[optionIndex] === optionButton.dataset.optionValue);
        const baseline = comparableVariants.length ? Math.min(...comparableVariants.map((candidate) => candidate.price)) : 0;
        const premium = choice ? choice.price - baseline : 0;
        note.hidden = premium <= 0;
        note.textContent = premium > 0 ? `+${money(premium)}` : '';
      });
    };
    const updateOrderMessage = (variant) => {
      if (!orderPanel || !orderMessage) return;
      const hasNamedVariant = variant && variant.title !== 'Default Title';
      const quoteOnly = root.dataset.productQuoteOnly === 'true' && variant?.price === 0;
      const messageTemplate = quoteOnly && orderPanel.dataset.orderMessageTemplateQuote
        ? orderPanel.dataset.orderMessageTemplateQuote
        : !hasNamedVariant && orderPanel.dataset.orderMessageTemplateSimple
          ? orderPanel.dataset.orderMessageTemplateSimple
          : orderPanel.dataset.orderMessageTemplate;
      const message = (messageTemplate || '')
        .replace('__PRODUCT__', root.dataset.productTitle || '')
        .replace('__VARIANT__', hasNamedVariant ? variant.title : '')
        .replace('__PRICE__', variant ? money(variant.price) : '');
      orderMessage.value = variant ? message : '';
      [orderInstagram, orderWhatsApp].filter(Boolean).forEach((link) => {
        link.setAttribute('aria-disabled', String(!variant));
        link.tabIndex = variant ? 0 : -1;
      });
      if (orderWhatsApp) {
        const whatsappUrl = new URL(orderWhatsApp.dataset.whatsappBaseUrl);
        if (variant) whatsappUrl.searchParams.set('text', message);
        else whatsappUrl.searchParams.delete('text');
        orderWhatsApp.href = whatsappUrl.toString();
      }
    };
    const updateFormatPriceNotes = (selected) => {
      if (!formatSelector || formatPriceNotes.length === 0) return;

      const formatIndex = Number(formatSelector.dataset.optionIndex);
      const vialFormat = [...formatSelector.options]
        .map((option) => option.value)
        .find((value) => value.toLowerCase().includes('lyophilized'));

      if (!Number.isInteger(formatIndex) || !vialFormat) return;

      const vialOptions = [...selected];
      vialOptions[formatIndex] = vialFormat;
      const vialVariant = variants.find((candidate) =>
        candidate.options.every((value, index) => value === vialOptions[index])
      );

      formatPriceNotes.forEach((note) => {
        const formatButton = note.closest('[data-option-button]');
        const formatValue = formatButton?.dataset.optionValue;
        if (!formatValue || !vialVariant) {
          note.textContent = 'Prepared before shipment';
          return;
        }

        const formatOptions = [...selected];
        formatOptions[formatIndex] = formatValue;
        const formatVariant = variants.find((candidate) =>
          candidate.options.every((value, index) => value === formatOptions[index])
        );
        const premium = formatVariant ? formatVariant.price - vialVariant.price : 0;
        note.textContent = premium > 0
          ? `+${money(premium)} · prepared before shipment`
          : 'Prepared before shipment';
      });
    };
    const readQuantity = () => {
      if (!quantityInput) return 1;
      const parsed = Number.parseInt(quantityInput.value, 10);
      const value = Number.isFinite(parsed) ? Math.max(1, parsed) : 1;
      quantityInput.value = String(value);
      if (quantityDecrease) quantityDecrease.disabled = value <= 1;
      return value;
    };
    const adjustQuantity = (delta) => {
      if (!quantityInput) return;
      quantityInput.value = String(Math.max(1, readQuantity() + delta));
      readQuantity();
    };
    quantityDecrease?.addEventListener('click', () => adjustQuantity(-1));
    quantityIncrease?.addEventListener('click', () => adjustQuantity(1));
    quantityInput?.addEventListener('change', readQuantity);
    quantityInput?.addEventListener('blur', readQuantity);
    readQuantity();
    const selectedVariant = () => {
      if (!selectors.length) return variants.find((variant) => String(variant.id) === variantInput.value) || variants[0];
      const selected = selectors.map((selector) => selector.value);
      return variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
    };
    const sync = () => {
      const selected = selectors.map(el => el.value);
      const variant = selectedVariant();
      selectors.forEach((selector, optionIndex) => {
        [...selector.options].forEach((option) => {
          option.disabled = !variants.some((candidate) => candidate.options[optionIndex] === option.value
            && candidate.options.slice(0, optionIndex).every((value, index) => value === selected[index]));
        });
      });
      optionButtons.forEach(optionButton => {
        const selector = selectors[Number(optionButton.dataset.optionIndex)];
        const option = [...(selector?.options || [])].find((choice) => choice.value === optionButton.dataset.optionValue);
        optionButton.disabled = submitting || !option || option.disabled;
        optionButton.setAttribute('aria-pressed', String(selector?.value === optionButton.dataset.optionValue));
      });
      updateFormatPriceNotes(selected);
      updateOptionPremiums(selected);
      updateOrderMessage(variant);
      variantInput.value = variant ? String(variant.id) : '';
      if (price) price.textContent = !variant ? 'Unavailable'
        : root.dataset.productComingSoon === 'true' ? root.dataset.comingSoonLabel
          : root.dataset.productQuoteOnly === 'true' && variant.price === 0 ? root.dataset.priceOnRequest || 'Price on request'
            : money(variant.price);
      if (summary) summary.textContent = [root.dataset.productTitle, ...(selectors.length ? selected : [])].join(' · ');
      if (button) {
        button.disabled = submitting || !variant?.available;
        button.textContent = submitting ? 'Adding…' : !variant ? 'Unavailable' : variant.available ? 'Add to bag' : 'Coming soon';
      }
      const selectedFormat = (formatSelector?.value || variant?.options.join(' ') || '').toLowerCase();
      root.dataset.selectedFormat = selectedFormat.includes('nasal') ? 'nasal' : selectedFormat.includes('pen') ? 'pen' : 'vial';
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant', variant.id);
      else url.searchParams.delete('variant');
      window.history.replaceState({}, '', url);
    };
    const setSubmitting = (busy) => {
      submitting = busy;
      if (busy) root.setAttribute('aria-busy', 'true');
      else root.removeAttribute('aria-busy');
      [...selectors, ...optionButtons, quantityInput, quantityDecrease, quantityIncrease].filter(Boolean).forEach((control) => { control.disabled = busy; });
      if (!busy) readQuantity();
      sync();
    };
    optionButtons.forEach(optionButton => optionButton.addEventListener('click', () => {
      const selector = selectors[Number(optionButton.dataset.optionIndex)];
      if (!selector) return;
      selector.value = optionButton.dataset.optionValue;
      selector.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    selectors.forEach((selector, optionIndex) => selector.addEventListener('change', () => {
      const selected = selectors.map((control) => control.value);
      let candidates = variants.filter((candidate) => candidate.options.slice(0, optionIndex + 1)
        .every((value, index) => value === selected[index]));
      if (candidates.length) {
        selectors.slice(optionIndex + 1).forEach((control, offset) => {
          const index = optionIndex + offset + 1;
          if (!candidates.some((candidate) => candidate.options[index] === control.value)) control.value = candidates[0].options[index];
          candidates = candidates.filter((candidate) => candidate.options[index] === control.value);
        });
      }
      sync();
    }));
    sync();

    orderInstagram?.addEventListener('click', (event) => {
      if (!selectedVariant()) {
        event.preventDefault();
        return;
      }
      if (!orderDialog || typeof orderDialog.showModal !== 'function') return;
      event.preventDefault();
      if (orderCopyStatus) orderCopyStatus.textContent = '';
      if (orderFallback) orderFallback.hidden = true;
      orderDialog.showModal();
    });
    orderWhatsApp?.addEventListener('click', (event) => {
      if (!selectedVariant()) event.preventDefault();
    });
    orderDialog?.querySelector('[data-order-close]')?.addEventListener('click', () => orderDialog.close());
    orderDialog?.addEventListener('click', (event) => {
      if (event.target === orderDialog) orderDialog.close();
    });
    orderDialog?.querySelector('[data-order-copy-open]')?.addEventListener('click', async (event) => {
      const copyButton = event.currentTarget;
      if (!orderMessage || !orderInstagram) return;
      copyButton.disabled = true;
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(orderMessage.value);
        window.location.assign(orderInstagram.href);
      } catch {
        orderMessage.focus();
        orderMessage.select();
        if (orderCopyStatus) orderCopyStatus.textContent = orderPanel.dataset.copyFallback;
        if (orderFallback) orderFallback.hidden = false;
      } finally {
        copyButton.disabled = false;
      }
    });

    const goToBag = () => {
      window.location.href = root.dataset.cartUrl || '/cart';
    };
    const getExtraOffer = () => {
      if (!extraDialog || root.dataset.selectedFormat === 'nasal') return null;
      const format = root.dataset.selectedFormat === 'pen' ? 'pen' : 'vial';
      return {
        id: Number(extraDialog.dataset[`${format}Id`]),
        available: extraDialog.dataset[`${format}Available`] === 'true',
        title: extraDialog.dataset[`${format}Title`],
        price: extraDialog.dataset[`${format}Price`],
        format
      };
    };
    const openExtraDialog = (offer) => {
      if (!extraDialog || !offer?.id || !offer.available) {
        goToBag();
        return;
      }
      extraDialog.dataset.offerId = String(offer.id);
      const copy = extraDialog.querySelector('[data-extra-copy]');
      const addExtra = extraDialog.querySelector('[data-extra-add]');
      if (copy) {
        copy.textContent = offer.format === 'pen'
          ? `Your prepared pen already includes standard pen needles. Would you like to add ${offer.title} for ${offer.price}?`
          : `Your vial order already includes the standard syringes. Would you like to add ${offer.title} for ${offer.price}?`;
      }
      if (addExtra) addExtra.textContent = `Add extra pack — ${offer.price}`;
      if (typeof extraDialog.showModal !== 'function') {
        goToBag();
        return;
      }
      extraDialog.showModal();
      window.requestAnimationFrame(() => extraDialog.querySelector('[data-extra-decline]')?.focus());
    };

    extraDialog?.querySelectorAll('[data-extra-decline]').forEach((decline) => decline.addEventListener('click', goToBag));
    extraDialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      goToBag();
    });
    extraDialog?.querySelector('[data-extra-add]')?.addEventListener('click', async (event) => {
      const extraButton = event.currentTarget;
      const extraStatus = extraDialog.querySelector('[data-extra-status]');
      extraButton.disabled = true;
      extraButton.textContent = 'Adding extra pack…';
      if (extraStatus) extraStatus.textContent = '';
      try {
        const response = await fetch(root.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: Number(extraDialog.dataset.offerId), quantity: 1}]})
        });
        if (!response.ok) throw new Error('Unable to add the extra pack');
        goToBag();
      } catch (error) {
        if (extraStatus) extraStatus.textContent = 'Your product is already in your bag, but the extra pack could not be added.';
        extraButton.disabled = false;
        const offer = getExtraOffer();
        extraButton.textContent = `Try extra pack again — ${offer?.price || ''}`.trim();
      }
    });

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      if (extraDialog?.open) extraDialog.close();
      setSubmitting(false);
    });

    root.querySelector('form').addEventListener('submit', async (event) => {
      event.preventDefault();
      if (root.hasAttribute('data-direct-order-only')) return;
      if (submitting) return;
      const variant = selectedVariant();
      if (!variant?.available) {
        sync();
        return;
      }
      const quantity = readQuantity();
      const extraOffer = getExtraOffer();
      setSubmitting(true);
      if (formStatus) formStatus.textContent = '';
      try {
        const response = await fetch(root.dataset.cartAddUrl || '/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body:JSON.stringify({items:[{id:variant.id, quantity}]})
        });
        if (!response.ok) {
          const result = await response.json().catch(() => ({}));
          throw new Error(typeof result.description === 'string' ? result.description : 'We could not add this selection. Please try again.');
        }
        root.removeAttribute('aria-busy');
        openExtraDialog(extraOffer);
      } catch (error) {
        setSubmitting(false);
        if (formStatus) formStatus.textContent = error.message || 'We could not add this selection. Please try again.';
      }
    });
  });
});
